import { QRPaymentReportAPI } from "../api"

export class QRPaymentReport {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
    this.paymentTimeStamp = props.paymentTimeStamp ? props.paymentTimeStamp.iso : null
    this.voidedDate = props.voidedDate ? props.voidedDate.iso : null
    this.reconciledTimeStamp = props.reconciledTimeStamp ? props.reconciledTimeStamp.iso : null
  }

  get voidedByFullName() {
    let res = "";
    if (this.voidedBy) {
      res = `${this.voidedBy.firstName} ${this.voidedBy.lastName}`;
    }
    return res;
  }

  static async getQRPaymentReportBetweenDateByMarket(marketId, startDate, endDate) {
    const { data } = await QRPaymentReportAPI.getQRPaymentReportBetweenDateByMarket(
      marketId,
      startDate,
      endDate
    );
    return data.result.map(item => new QRPaymentReport(item));
  }
  
  static async getQRPaymentReportBetweenDateByProject(formData) {
    const { data } = await QRPaymentReportAPI.getQRPaymentReportBetweenDateByProject(formData);
    return data.result.map(item => new QRPaymentReport(item));
  }
}